import {store} from "store";
import React from "react";
import $ from "jquery";
import {getInfoFromLocalStorage} from "../actions";
import {message} from "antd";
import request from "../base/request";

const USER_KEY = "user_key";

export function uuid() {
    let s = [];
    let hexDigits = "0123456789abcdef";
    for (let i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4";  // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);  // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = "_";
    let uuid = s.join("");
    return uuid;
}
window.getUUID = uuid;

export function letterUUID() {
    let s = [];
    let hexDigits = "abcdefghijklmnop";
    for (let i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "z";  // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);  // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = "_";
    let uuid = s.join("");
    return uuid;
}

/**
 * 文件大小转换
 * @param Num size 单位 b
 * @returns {string}
 */
export function unitConvert(size) {
    let sizeVal;
    if (size < 0.1 * 1024) {
        sizeVal = `${size.toFixed(2)}B`;
    } else if (size < 0.1 * 1024 * 1024) {
        sizeVal = `${(size / 1024).toFixed(2)}KB`;
    } else if (size < 0.1 * 1024 * 1024 * 1024) {
        sizeVal = `${(size / (1024 * 1024)).toFixed(2)}MB`;
    } else {
        sizeVal = `${(size / (1024 * 1024 * 1024)).toFixed(2)}GB`;
    }
    return sizeVal;
}

/**
 * 时间戳转成日期时间
 * @param m
 * @returns {string}
 */
export function add0(m) {
    return m < 10 ? "0" + m : m;
}

export function formatDate(date_) {
    //shijianchuo是整数，否则要parseInt转换
    let time = new Date(date_);
    let y = time.getFullYear();
    let m = time.getMonth() + 1;
    let d = time.getDate();
    let h = time.getHours();
    let mm = time.getMinutes();
    let s = time.getSeconds();
    return y + "-" + add0(m) + "-" + add0(d) + " " + add0(h) + ":" + add0(mm) + ":" + add0(s);
}

export function formatToDay(date_) {
    //shijianchuo是整数，否则要parseInt转换
    let time = new Date(date_);
    let y = time.getFullYear();
    let m = time.getMonth() + 1;
    let d = time.getDate();
    let h = time.getHours();
    let mm = time.getMinutes();
    let s = time.getSeconds();
    return y + "-" + add0(m) + "-" + add0(d);
}

export function formatMediaDate(date_) {
    //shijianchuo是整数，否则要parseInt转换

    let newDate;
    if (typeof date_ === "number") {
        newDate = date_;
    } else if (typeof date_ === "string" && date_.indexOf("-") > -1) {
        newDate = Date.parse(date_.replace(/-/g, "/"));
    } else {
        newDate = date_;
    }

    let time = new Date(newDate);
    let y = time.getFullYear();
    let m = time.getMonth() + 1;
    let d = time.getDate();
    let h = time.getHours();
    let mm = time.getMinutes();
    let s = time.getSeconds();
    return y + "/" + add0(m) + "/" + add0(d);
}

export function resourceFormatDate(date_) {
    //shijianchuo是整数，否则要parseInt转换

    let newDate;
    if (typeof date_ === "number") {
        newDate = date_;
    } else if (typeof date_ === "string" && date_.indexOf("-") > -1) {
        newDate = Date.parse(date_.replace(/-/g, "/"));
    } else {
        newDate = date_;
    }

    let time = new Date(newDate);
    let y = time.getFullYear();
    let m = time.getMonth() + 1;
    let d = time.getDate();
    let h = time.getHours();
    let mm = time.getMinutes();
    let s = time.getSeconds();
    return y + "." + add0(m) + "." + add0(d);
}

export function formatTime(date_) {
    //shijianchuo是整数，否则要parseInt转换
    var time = new Date(date_);
    var y = time.getFullYear();
    var m = time.getMonth() + 1;
    var d = time.getDate();
    var h = time.getHours();
    var mm = time.getMinutes();
    var s = time.getSeconds();
    return y + "-" + add0(m) + "-" + add0(d) + " " + add0(h) + ":" + add0(mm);
}

/**
 * 保存用户
 * @param user
 */
export function saveUser(user) {
    store.set(USER_KEY, user);
}

/**
 * 获取用户
 * @returns {*}
 */
export function getUser() {
    return store.get(USER_KEY);
}

/**
 * 清除用户
 * @returns {*}
 */
export function removeUser() {
    return store.remove(USER_KEY);
}


export function converFileSize(limit) {
    let size = "";
    if (limit < 0.1 * 1024) { //如果小于0.1KB转化成B
        size = limit.toFixed(2) + "B";
    } else if (limit < 0.1 * 1024 * 1024) {//如果小于0.1MB转化成KB
        size = (limit / 1024).toFixed(2) + "KB";
    } else if (limit < 0.1 * 1024 * 1024 * 1024) { //如果小于0.1GB转化成MB
        size = (limit / (1024 * 1024)).toFixed(2) + "MB";
    } else { //其他转化成GB
        size = (limit / (1024 * 1024 * 1024)).toFixed(2) + "GB";
    }

    let sizestr = size + "";
    let len = sizestr.indexOf("\.");
    let dec = sizestr.substr(len + 1, 2);
    if (dec === "00") {//当小数点后为00时 去掉小数部分
        return sizestr.substring(0, len) + sizestr.substr(len + 3, 2);
    }
    return sizestr;
}


//将秒数转换为时分秒格式
export function formatSeconds(value) {
    let theTiMs = parseInt(value);// 毫秒
    let theTime = 0;// 秒
    let middle = 0;// 分
    let hour = 0;// 小时
    if (theTiMs > 1000) {
        theTime = parseInt(theTiMs / 1000);
        theTiMs = parseInt(theTiMs % 1000);
        if (theTime > 60) {
            middle = parseInt(theTime / 60);
            theTime = parseInt(theTime % 60);
            if (middle > 60) {
                hour = parseInt(middle / 60);
                middle = parseInt(middle % 60);
            }
        }
    }

    if (theTime < 10) {
        theTime = 0 + "" + theTime;
    }
    let result = "" + theTime + ":" + theTiMs;
    // if(middle > 0) {
    if (middle < 10) {
        middle = 0 + "" + middle;
    }
    result = "" + middle + ":" + result;
    // }
    if (hour > 0) {
        result = "" + parseInt(hour) + ":" + result;
    }
    return result;
}
export function formatSecondsFont(value) {
        let theTime = parseInt(value);// 秒
        let middle= 0;// 分
        let hour= 0;// 小时
        if(theTime > 60) {
            middle= parseInt(theTime/60);
            theTime = parseInt(theTime%60);
            if(middle> 60) {
                hour= parseInt(middle/60);
                middle= parseInt(middle%60);
            }
        }
        let result = "00分" + parseInt(theTime)+"秒";
        if(middle > 0) {
            result = ""+parseInt(middle)+"分"+result.substr(3);
        }
        if(hour> 0) {
            result = ""+parseInt(hour)+"时"+result;
        }
        return result;
    }
export function formatFont(value) {
    let millisecond = parseInt(value)/1000
    let theTime = millisecond;// 秒
    let middle= 0;// 分
    let hour= 0;// 小时
    if(theTime > 60) {
        middle= parseInt(theTime/60);
        theTime = parseInt(theTime%60);
        if(middle> 60) {
            hour= parseInt(middle/60);
            middle= parseInt(middle%60);
        }
    }
    let result = parseInt(theTime)+"s";
    if(middle > 0) {
        result = ""+parseInt(middle)+"m"+result
    }
    if(hour> 0) {
        result = ""+parseInt(hour)+"h"+result;
    }
    return result;
}
/*浏览器内部转换器实现html解码*/
export function htmlDecode(text) {
    return String(text || "").replace(/&([a-zA-Z0-9]+;)/g, "&amp;$1").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/'/g, "&#39;").replace(/"/g, "&quot;");
}


/*传入html字符串源码即可*/
export function htmlEscape(text) {
    return text.replace(/[<>"&]/g, function (match, pos, originalText) {
        switch (match) {
            case "<":
                return "&lt;";
            case ">":
                return "&gt;";
            case "&":
                return "&amp;";
            case "\"":
                return "&quot;";
            case "\'":
                return "&#x27;";
            case "\/":
                return "&#x2F;";
            default:
                ;
        }
    });
}

/**
 * 动态移除css或者js样式表
 * @param filename
 * @param filetype
 */
export function removejscssfile(filename, filetype) {
    let targetelement = (filetype === "js") ? "script" : (filetype === "css") ? "link" : "none";
    let targetattr = (filetype === "js") ? "src" : (filetype === "css") ? "href" : "none";
    let allsuspects = document.getElementsByTagName(targetelement);
    for (let i = allsuspects.length; i >= 0; i--) {
        if (allsuspects[i] && allsuspects[i].getAttribute(targetattr) !== null && allsuspects[i].getAttribute(targetattr).indexOf(filename) != -1)
            allsuspects[i].parentNode.removeChild(allsuspects[i]);
    }
}

//动态加载一个js/css文件
export function loadJsCssFile(filename, filetype) {
    let fileref = null;
    if (filetype === "js") {
        fileref = document.createElement("script");
        fileref.setAttribute("type", "text/javascript");
        fileref.setAttribute("src", filename);
    } else if (filetype === "css") {
        fileref = document.createElement("link");
        fileref.setAttribute("rel", "stylesheet");
        fileref.setAttribute("type", "text/css");
        fileref.setAttribute("href", filename);
    }
    if (fileref)
        document.getElementsByTagName("head")[0].appendChild(fileref);
}

export function isIE() { //ie?
    return (!!window.ActiveXObject || "ActiveXObject" in window);
}


export function timeago(date) {
    if (!date) {
        return "";
    }
    let dateTimeStamp;
    if (typeof date === "number") {
        dateTimeStamp = date;
    } else if (typeof date === "string" && date.indexOf("-") > -1) {
        dateTimeStamp = Date.parse(date.replace(/-/g, "/"));
    } else {
        dateTimeStamp = date;
    }

    let result;
    let minute = 1000 * 60;
    let hour = minute * 60;
    let day = hour * 24;
    let halfamonth = day * 15;
    let month = day * 30;
    let now = new Date().getTime();
    let diffValue = now - new Date(dateTimeStamp).getTime();
    if (diffValue < 0) {
        return;
    }
    let monthC = diffValue / month;
    let weekC = diffValue / (7 * day);
    let dayC = diffValue / day;
    let hourC = diffValue / hour;
    let minC = diffValue / minute;
    if (monthC >= 1) {
        if (monthC <= 12)
            result = "" + parseInt(monthC) + "月前";
        else {
            result = "" + parseInt(monthC / 12) + "年前";
        }
    } else if (weekC >= 1) {
        result = "" + parseInt(weekC) + "周前";
    } else if (dayC >= 1) {
        result = "" + parseInt(dayC) + "天前";
    } else if (hourC >= 1) {
        result = "" + parseInt(hourC) + "小时前";
    } else if (minC >= 1) {
        result = "" + parseInt(minC) + "分钟前";
    } else {
        result = "刚刚";
    }
    return result;
}

//获取url 参数
export function GetQueryValue(queryName) {
    let query = decodeURI(window.location.href.substring(window.location.href.indexOf("?") + 1));
    let vars = query.split("&");
    for (let i = 0; i < vars.length; i++) {
        let pair = vars[i].split("=");
        if (pair[0] == queryName) {
            return pair[1];
        }
    }
    return null;
}

// 转为unicode 编码
export function encodeUnicode(str) {
    let res = [];
    for (let i = 0; i < str.length; i++) {
        res[i] = ("00" + str.charCodeAt(i).toString(16)).slice(-4);
    }
    return "\\u" + res.join("\\u");
}

// 解码
export function decodeUnicode(str) {
    str = str.replace(/\\/g, "%");
    return unescape(str);
}

//get 拼接参数
export function params(obj) {
    let result = "";
    let item;
    for (item in obj) {
        if (typeof obj[item] === "string" && obj[item].length) {
            obj[item] = obj[item].trim();
        }
        if (obj[item] !== null && obj[item] !== "") {
            if (/*obj[item] &&*/ String(obj[item])) {
                result += `&${item}=${obj[item]}`;
            }
        }
    }
    if (result) {
        result = "?" + result.slice(1);
    }
    return result;
}

//格式化时间，取时间间隔分为数组 "2020/04/01 ","2020/04/07 ",时间后的空格不能少，
export function formatEveryDay(start, end) {
    let ydStart = start;
    let ydEnd = end;
    const startTime = ydStart.split(" ")[0];
    const endTime = ydEnd.split(" ")[0];
    const intervalDay = (getDate(endTime).getTime() - getDate(startTime).getTime()) / (1000 * 60 * 60 * 24);
    /* if (intervalDay >= 1) {
         console.log(formatEveryDay(startTime,endTime))
         let timeArr = formatEveryDay(startTime, endTime)
         // console.log(group(timeArr, 2))
         return success(timeArr);
     }*/

    let dateList = [];
    let startTimeC = getDate(start);
    let endTimeC = getDate(end);

    while ((endTimeC.getTime() - startTimeC.getTime()) >= 0) {
        let year = startTimeC.getFullYear();
        let month = startTimeC.getMonth() + 1 < 10 ? "0" + (startTimeC.getMonth() + 1) : startTimeC.getMonth() + 1;
        let day = startTimeC.getDate().toString().length == 1 ? "0" + startTimeC.getDate() : startTimeC.getDate();
        dateList.push(year + "/" + month + "/" + day + " " + ydStart.split(" ")[1]);
        startTimeC.setDate(startTimeC.getDate() + 1);
    }
    dateList[dateList.length - 1] = endTime + " " + ydEnd.split(" ")[1];
    return dateList;
}

function getDate(datestr) {
    let temp = datestr.split("/");
    let date = new Date(temp[0], temp[1] - 1, temp[2]);
    return date;
}


//敏感词检测方法
export function filtion(arr, val) {
    let re = "";
    let value = val;
    if (arr.length === 0) {
        return {
            key: false,
            value: value
        };
    }
    for (let i = 0; i < arr.length; i++) {
        //定义正则表示式对象
        //利用RegExp可以动态生成正则表示式
        let r = new RegExp(arr[i], "ig");
        if (r.test(value)) {
            value = value.replace(r, "<font color='red' style='background-color: #FFE5E5; padding: 5px;'>" + arr[i] + "</font>");
            if (i === arr.length - 1) {
                return {
                    key: false,
                    value: value
                };//这里是有敏感词的情况下，已经标红，并且提示为false，可以用来提示用户您有敏感词
            }

        } else {
            if (i === arr.length - 1) {
                return {
                    key: true,
                    value: value
                };//这里是有敏感词的情况下，已经标红，并且提示为false，可以用来提示用户您有敏感词
            }
        }
    }
}

//字符换转成html
export function encodeHtml(str) {
    let encodedStr = "";
    if (str == "") return encodedStr;
    else {
        for (let i = 0; i < str.length; i++) {
            encodedStr += "&#" + str.substring(i, i + 1).charCodeAt().toString(10) + ";";
        }
    }
    return encodedStr;
}


export function exportData(params, url) {
    let form = document.createElement("form");
    form.style.display = "none";
    let startUrl = "/dynamic";
    if (!url.startsWith(startUrl)) {
        url = startUrl + url;
    }
    form.action = url;
    form.method = "post";
    document.body.appendChild(form);//设置请求格式
    for (let key in params) {
        if (typeof params[key] == "object") {
            for (let i = 0; i < params[key].length; i++) {
                let input = document.createElement("input");
                input.type = "hidden";
                input.name = key;
                console.log(key);
                input.value = params[key][i];
                form.appendChild(input);
            }
        } else {
            let input = document.createElement("input");
            input.type = "hidden";
            input.name = key;
            input.value = params[key];
            form.appendChild(input);
        }
    }// 请求内容整理，按实际情况进行处理
    form.submit();
    form.remove();
}

//打开新窗口共通
export function openNewWindow(url) {
    let width = 1220;
    let height = 767;
    let new_url = url;
    let left = (window.innerWidth - width) / 2;
    let top = (window.innerHeight - height) / 2;
    window.open(new_url, "newindow", "height=" + height + ",width=" + width + ",top=" + top + ",left=" + left + ",toolbar=no,menubar=no,scrollbars=no,resizable=yes,location=yes,status=yes");
}

export function createFromData(params) {
    let formData = new FormData();
    for (let key in params) {
        formData.append(key, params[key]);
    }
    return formData;
}

export function formatData(data) {
    if (!data)
        return {};
    const result = Object.entries(data).map(([key, value]) =>
        key + "=" + value).join("&");
    return result;
}


/**
 * 用户权限控制；
 * @param permissionCode
 */
export function permissionCheck(permissionCode) {
    let permissioins = getInfoFromLocalStorage("permissions");
    if (!permissioins) {
        return false;
    }
    let hasPermission = false;
    if (permissioins.indexOf(permissionCode) > -1) {
        hasPermission = true;
    }
    return hasPermission;
}

/**获取文件的后缀*/
export function getSubffix(name) {
    if (name && (name.lastIndexOf(".") !== -1)) {
        return name.substring(name.lastIndexOf(".") + 1);
    }
    return "";
}
/**获取文件的文件名称*/
export function getFileName(url) {
    if (url && (url.lastIndexOf("/") !== -1)) {
        return url.substring(url.lastIndexOf("/") + 1);
    }
    return "";
}
/**
 * 根据图片url转为 图片文件对象
 * @param url
 * @returns {Promise<unknown>}
 */
export function getImageFileFromUrl(url) {
    let ext = getSubffix(url);
    let name = "未命名.png";
    if(ext && (["jpg","jpeg","gif","png","bmp","JPG","JPEG","GIF","PNG","BMP"].indexOf(ext) > -1)){
        name = getFileName(url);
    }else{
        ext = getSubffix(name);
    }
    return new Promise((resolve, reject) => {
        let blob = null;
        let xhr = new XMLHttpRequest();
        xhr.open("GET", url);
        xhr.setRequestHeader('Accept', 'image/png');
        xhr.responseType = "blob";
        // 加载时处理
        xhr.onload = () => {
            // 获取返回结果
            blob = xhr.response;
            let imgFile = new File([blob], name, { type: `image/${ext}` });
            // 返回结果
            resolve(imgFile);
        };
        xhr.onerror = (e) => {
            reject(e)
        };
        // 发送
        xhr.send();
    });
}

export function isURL(str_url) {// 验证url
    let strRegex = "^((https|http|ftp|rtsp|mms)?://)"
        + "?(([0-9a-z_!~*'().&=+$%-]+: )?[0-9a-z_!~*'().&=+$%-]+@)?" // ftp的user@
        + "(([0-9]{1,3}\.){3}[0-9]{1,3}" // IP形式的URL- 199.194.52.184
        + "|" // 允许IP和DOMAIN（域名）
        + "([0-9a-z_!~*'()-]+\.)*" // 域名- www.
        + "([0-9a-z][0-9a-z-]{0,61})?[0-9a-z]\." // 二级域名
        + "[a-z]{2,6})" // first level domain- .com or .museum
        + "(:[0-9]{1,4})?" // 端口- :80
        + "((/?)|" // a slash isn't required if there is no file name
        + "(/[0-9a-z_!~*'().;?:@&=+$,%#-]+)+/?)$";
    let re = new RegExp(strRegex);
    return re.test(str_url);
}


//判断当前浏览器是否是IE;
export function isIe() {
    let userAgent = navigator.userAgent;
    // 判断是否为小于IE11的浏览器
    let isLessIE11 = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1;
    // 判断是否为IE的Edge浏览器
    let isEdge = userAgent.indexOf("Edge") > -1 && !isLessIE11;
    return isEdge;
}
export function requests(url, method, body, callback) {
    window.loading&&window.loading.show();
    if (method === 'post') {
        post(url, body, (data) => {
            window.loading && window.loading.hide();
            if(data.status){
                if(data.status===200){
                    callback(data.data)
                }else{
                    message.error(data.msg)
                }
            } else {
                callback(data)
            }
        });
    }
    if (method === 'get') {
        get(url, body, (data) => {
            window.loading&&window.loading.hide();
            if(data.status){
                if(data.status===200){
                    callback(data.data)
                }else{
                    message.error(data.msg)
                }
            }else {
                callback(data)
            }
        });
    }
    if(method === 'getFile'){
        exportFiles(url, body);
    }
}
export function post(url, params, callBack) {
    //fetch请求
    url = url + '?time=' + new Date().getTime();
    fetch(url, {
        method: 'post',
        cache: 'no-cache',
        body: JSON.stringify(params),
        headers: headerJson,
        credentials: 'include'
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.log(error)
    })
}
export function exportFiles(url, params) {
    if (params) {
        let paramsArray = [];
        //拼接参数
        Object.keys(params).forEach(key => paramsArray.push(key + '=' + params[key]));
        if (url.search(/\?/) === -1) {
            url += '?' + paramsArray.join('&')
        } else {
            url += '&' + paramsArray.join('&')
        }
    }
    url=url.includes('?')?url+'&time='+ new Date().getTime():url+'?time='+ new Date().getTime();//get方法浏览器会直接把资源转换成文件，不需要前台自己转，post的时候需要自己转
    window.location.href=url;
}
export const headerJson = {
    "Pragma": 'no-cache',
    'Cache-Control': 'no-cache',
    'Content-Type': 'application/json;charset=UTF-8',
};
export function get(url, params, callBack) {
    if (params) {
        let paramsArray = [];
        //拼接参数
        Object.keys(params).forEach(key => paramsArray.push(key + '=' + params[key]))
        if (url.search(/\?/) === -1) {
            url += '?' + paramsArray.join('&')
        } else {
            url += '&' + paramsArray.join('&')
        }
    }
    url=url.includes('?')?url+'&time='+ new Date().getTime():url+'?time='+ new Date().getTime();
    //fetch请求
    fetch(url, {
        method: 'GET',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include'
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.log(error)
    })
}
export const headers = {
    "Pragma": 'no-cache',
    'Cache-Control': 'no-cache',
    'Content-Type': 'application/x-www-form-urlencoded',
};
export function filtUrl(val) {
    let re = "";
    let value = val;
    let arr = ["%", "#"];
    if (arr.length === 0) {
        return val;
    }
    for (let i = 0; i < arr.length; i++) {
        //定义正则表示式对象
        //利用RegExp可以动态生成正则表示式
        //let r = new RegExp(arr[i], "ig");'
        //console.log(r)
        if (value.indexOf(arr[i]) > -1) {
            switch (arr[i]) {
                case "%":
                    value = value.replace(/%/g, "%25");
                case "#":
                    value = value.replace(/#/g, "%23");
            }

            if (i === arr.length - 1) {
                return value;//这里是有敏感词的情况下，已经标红，并且提示为false，可以用来提示用户您有敏感词
            }

        } else {
            if (i === arr.length - 1) {
                return value;//这里是有敏感词的情况下，已经标红，并且提示为false，可以用来提示用户您有敏感词
            }
        }
    }
}

export function showCommentEmotions(text, map) {
    let reg = /(\[[^\]]+\])/;

    let matchResult = text && text.match(reg);
    if (!matchResult) {
        //未匹配出表情
        return <span>{text}</span>;
    } else {
        //替换表情
        let tag;
        let key = matchResult[0];
        let url = map[key];
        if (url) {
            //查询到表情
            tag = "<img style='width:20px;height:20px;margin:0px 2px;' src=" + url + ">";
        } else {
            //为查询到表情
            tag = "<span>" + key + "</span>";
        }

        return (
            <span>{text.substr(0, matchResult.index)}
                <span
                    dangerouslySetInnerHTML={{__html: tag}}></span>{showCommentEmotions(text.substr(matchResult.index + key.length), map)}
                </span>
        );
    }
}

// 数组去重每个字段 数组, 键值；
export function ArrayDuplication(oldArr, key) {
    let arr = oldArr;
    let result = {};
    for (let i = 0; i < arr.length; i++) {
        result[arr[i][key]] = arr[i];
    }

    let finalResult = [];
    for (let item in result) {
        finalResult.push(result[item]);
    }

    return finalResult;
}

/**
 * 获取当前工程的名称
 * @returns {string}
 */
export function applicationName() {
    let href = window.top.location.href;
    return href.replace(/.*\/cm-sites\/([^\/]*).*/, "$1");
}

/**
 * 遍历树组件
 * @param tree
 * @param func
 */
export function forEachTree(tree, func) {
    tree.forEach(node => {
        func(node);
        node.children && node.children.length && forEachTree(node.children, func);
    });
}

export function formatDateByFmt(d, fmt) {
    const date = new Date(d);
    let o = {
        "M+": date.getMonth() + 1,                 //月份
        "d+": date.getDate(),                    //日
        "h+": date.getHours(),                   //小时
        "m+": date.getMinutes(),                 //分
        "s+": date.getSeconds(),                 //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        "S": date.getMilliseconds()             //毫秒
    };
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        }
    }
    return fmt;
}

export function handleNumber(num) {
    if(num >= 100000) {
        return "10万+";
    }else if(num >= 10000) {
        return (num / 10000).toFixed(1) + "万";
    }else {
        return num.toString();
    }
}

export function generateTreeData(treeData, treeDataIndex) {
    const newTreeData = [];
    for (let i = 0; i < treeData.length; i++) {
        const treeNode = treeData[i];
        let item = {
            id: treeNode[treeDataIndex["id"]],
            title: treeNode[treeDataIndex["title"]],
            key: treeNode[treeDataIndex["key"]],
            icon: treeNode.icon,
            data: treeNode,
            disableCheckbox: treeNode.disableCheckbox
        };

        treeNode[treeDataIndex["children"]] && (item.children = generateTreeData(treeNode[treeDataIndex["children"]], treeDataIndex));
        newTreeData.push(item);
    }
    return newTreeData;
}

// 遍历树
export function treeForEach(tree, func, children = "children") {
    tree.forEach(node => {
        func(node);
        node[children] && node[children].length && treeForEach(node[children], func, children);
    });
}

// 遍历树-逆序
export function treeForEachReverse(tree, func, children = "children") {
    tree.forEach(node => {
        node[children] && node[children].length && treeForEach(node[children], func);
        func(node);
    });
}

export function filterForEach(tree, func) {
    const treeData = JSON.parse(JSON.stringify(tree));
    return treeData.filter(node => {
        node.children = node.children && filterForEach(node.children, func);
        return func(node) || (node.children && node.children.length);
    });
}

// 匹配中文，英文字母和数字及_  同时判断输入长度
export function validateName(value, {min, max, includesZhCN = true} = {},regTxt="") {
    let reg;
    if (includesZhCN) {
        reg = new RegExp(`^[\u9FA6-\u9FCB\u3400-\u4DB5\u4E00-\u9FA5\u25CF\u00B7_a-zA-Z0-9${regTxt}]{${min},${max}}$`);
    } else {
        reg = new RegExp(`^[_a-zA-Z0-9${regTxt}]{${min},${max}}$`);
    }
    return reg.test(value);
}

// 电话校验
export function validateNumber(value) {
    let reg = new RegExp(`^[0-9-]+$`);
    return reg.test(value);
}

export function validatePassword(value) {
    let reg = new RegExp(`^[0-9a-zA-Z._~!@#$^&*]{7,20}$`);
    return reg.test(value);
}

export function getCurrentUser() {
    let currentUser = {};
    try {
        currentUser = getInfoFromLocalStorage("currentUser")
    } catch (e) {
        // message.error("用户信息获取失败");
    }
    return currentUser;
}

export function changeSize(value){
        if (value < 1024) {
            return value.toFixed(2) + 'B'
        } else if (value >= 1024 && value < Math.pow(1024, 2)) {
            return parseFloat(value / 1024).toFixed(2) + 'K'
        } else if(value >= Math.pow(1024, 2) && value < Math.pow(1024, 3)){
            return parseFloat(value / Math.pow(1024, 2)).toFixed(2) + 'M';
        } else if(value > Math.pow(1024, 3)){
            return parseFloat(value / Math.pow(1024, 3)).toFixed(2) + 'G';
        } else if(value > Math.pow(1024, 4)){
            return parseFloat(value / Math.pow(1024, 4)).toFixed(2) + 'T';
        }

}
export function requestWithoutLoading(url, method, body, callback) {
    if (method === 'post') {
        post(url, body, (data) => {
            if(data.status){
                if(data.status===200){
                    callback(data.data)
                }else{
                    message.error(data.msg)
                }
            } else {
                callback(data)
            }
        });
    }
    if (method === 'get') {
        get(url, body, (data) => {
            if(data.status){
                if(data.status===200){
                    callback(data.data)
                }else{
                    message.error(data.msg)
                }
            }else {
                callback(data)
            }
        });
    }
    if(method === 'getFile'){
        exportFiles(url, body);
    }
}

export const computeDuration = (duration)=> {
    if (!duration) {
        return `0秒`;
    }
    const seconds = parseInt((duration / 1000) % 60);
    const days = Math.floor(duration / (1000 * 60 * 60 * 24));
    const hours = Math.floor((duration % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((duration % (1000 * 60 * 60)) / (1000 * 60));
    if (days > 0) {
        return `${days}天${hours}⼩时${minutes}分钟${seconds}秒`;
    }
    if (hours > 0) {
        return `${hours}⼩时${minutes}分钟${seconds}秒`;
    }
    if (minutes > 0) {
        return `${minutes}分钟${seconds}秒`;
    }
    return `${seconds}秒`;
}

export const computeTime = (duration)=> {
    if (!duration) {
        return `0s`;
    }
    const seconds = parseInt((duration / 1000) % 60);
    const days = Math.floor(duration / (1000 * 60 * 60 * 24));
    const hours = Math.floor((duration % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((duration % (1000 * 60 * 60)) / (1000 * 60));
    if (days > 0) {
        return `${days}d${hours}h${minutes}m${seconds}s`;
    }
    if (hours > 0) {
        return `${hours}h${minutes}m${seconds}s`;
    }
    if (minutes > 0) {
        return `${minutes}m${seconds}s`;
    }
    return `${seconds}s`;
}


export function base64Encode(str){
    // 对字符串进行编码
    let encode = encodeURIComponent(str);
    // 对编码的字符串转化base64
    let base64 = btoa(encode);
    return base64;
}

/**
 * 判断两个对象是否相同
 * @param object1
 * @param object2
 * @param filterAttrs 需要过滤的属性
 * @param attrs 需要检查的属性
 * @returns {boolean}
 */
export function isSelf (object1, object2, filterAttrs=[], attrs=null){
    if(!filterAttrs){
        filterAttrs = [];
    }
    if(object1 === object2){
        return true;
    }
    if((typeof object1 === "object") && (typeof object2 === "object")){
        for(let attr in object1){
            if(filterAttrs.indexOf(attr) === -1){
                if(!attrs || attrs.indexOf(attr) > -1){
                    if(object1[attr] !== object2[attr]){
                        return false;
                    }
                }
            }
        }
        for(let attr in object2){
            if(filterAttrs.indexOf(attr) === -1){
                if(!attrs || attrs.indexOf(attr) > -1){
                    if(object1[attr] !== object2[attr]){
                        return false;
                    }
                }
            }
        }
    }
    return true;
};



/**
 * 格式化菜单url
 * */

export function findUrlData(url, navigateData) {
    let sons;
    let name;
    let stopFind = false;
    let find = (data, level, levelOneBrothers, levelOneName) => {
        if (stopFind)
            return;
        if ((!data.child || data.child.length === 0) && (!data.float_ || data.float_.length === 0)) {
            if (data.path === url) {
                sons = levelOneBrothers;
                name = levelOneName;
                stopFind = true;
            }
            return;
        }
        let tempSons = data.float_;
        if (!tempSons || tempSons.length === 0) {
            tempSons = data.child;
        }
        if (stopFind)
            return;
        tempSons && tempSons.map(item => {
            if (stopFind)
                return;
            let tempItemSons = item.float_;
            if (!tempItemSons || tempItemSons.length === 0) {
                tempItemSons = item.child;
            }
            if (level == 0) {//取第一级的信息
                find(item, level + 1, tempItemSons, item.menuName);
            } else {
                find(item, level + 1, levelOneBrothers, levelOneName);
            }
        })
    };
    find({child: navigateData}, 0, null, null);
    return {stopFind, sons, name};
};

export function transferSpecialCharacter(value) {
    let arr = ['(', '[', '{', '/', '^', '$', '¦', '}', ']', ')', '?', '*', '+', '.', "'", '"']
    for (let i = 0; i < arr.length; i++) {
        if (value) {
            if (value.indexOf(arr[i]) > -1) {
                const reg = (str) => str.replace(/[\[\]\/\{\}\(\)\*\'\"\¦\+\?\.\\\^\$\|]/g, "\\$&")
                value = reg(value)
            }
        }
    }
    return value;
}

export function filterXSS(oriStr) {
    if (!oriStr) {
        return oriStr;
    }
    // 不能直接转换为符号，标签要被当做标签处理才行
    oriStr = oriStr.replace(/alert/g, 'console.log');
    return oriStr
    var charCodes = ['3c', '3e', '27', '22', '28', '29', '60', {format: 'script{}', chr: '3a'}];//要转义字符的16进制ASCII码[1<  2>  3'  4"  5(  6)  7`]
    var xssChars = [], filterChars = [], tmpFormat = '{}', tmpChr;
    for (var i = 0; i < charCodes.length; i++) {
        if ('string' == typeof charCodes[i]) {
            tmpFormat = '{}';
            tmpChr = charCodes[i];
        } else {
            tmpFormat = charCodes[i].format;
            tmpChr = charCodes[i].chr
        }
        xssChars.push(tmpFormat.replace('{}', '\\u00' + tmpChr));
        xssChars.push(tmpFormat.replace('{}', '%' + tmpChr));//1次encode
        xssChars.push(tmpFormat.replace('{}', '%25' + tmpChr));//2次encode
        filterChars.push(tmpFormat.replace('{}', '&#x' + tmpChr + ';'));
        filterChars.push(tmpFormat.replace('{}', '%26%23x' + tmpChr + '%3B'));//1次encode
        filterChars.push(tmpFormat.replace('{}', '%2526%2523x' + tmpChr + '%253B'));//2次encode
    }
    for (var i = 0; i < xssChars.length; i++) {
        oriStr = oriStr.replace(new RegExp(xssChars[i], 'gi'), filterChars[i]);
    }
//预防script:
    oriStr = oriStr.replace(/script[\u000d\u000a\u0020]+\:/, 'script:');
    return oriStr;
}


export function filterAlert(oriStr) {
    return oriStr?oriStr.replace(/alert/g, ""):''; //去掉alert
}

export function downloadImg(imgsrc, name) {
    let image = new Image();
    // 解决跨域 Canvas 污染问题
    image.setAttribute("crossOrigin", "anonymous");
    image.onload = function () {
        let canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        let context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        let url = canvas.toDataURL("image/png"); //得到图片的base64编码数据
        let a = document.createElement("a"); // 生成一个a元素
        let event = new MouseEvent("click"); // 创建一个单击事件
        a.download = name || "photo"; // 设置图片名称
        a.href = url; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
    };
    image.src = imgsrc;
};
/**
 * 获取视频的某一帧图片
 * @param{string} url 视频地址
 * @param{string} md5 视频md5
 * @param{number} second 帧数（秒）
 * @param{function} call 回调
 * @returns {string}
 */
export function getImgByVideo({md5,url,second,call,loading}) {
    if(typeof url === "string" && second>0) {
        if(url?.length) {
            getImgByVideoUrl({md5,url,second,call,loading})
        } else {
            call&&call("")
        }
        // if(md5?.length) {
        //     getImgByVideoMd5({md5,url,second,call,loading})
        // } else {
        //     getMd5ByUrl({loading,md5,url,second,call: function (videoMd5) {
        //         if(videoMd5) {
        //             getImgByVideoMd5({md5:videoMd5,url,second,call,loading})
        //         } else {
        //             call&&call("")
        //         }
        //         }})
        // }
    } else {
        call&&call("")
    }
}
function getImgByVideoUrl({md5,url,second,call,loading=true}) {
    request({
        url: '/storage/cutFramePicture',
        body: {url,second},
        loading,
        callBack: function (res) {
            call&&call(res?.path)
        },
    })
}
function getMd5ByUrl({md5,url,second,call,loading=true}) {
    request({
        url: '/storage/getStorageFileByUrl',
        body: {url},
        loading,
        callBack: function (res) {
            call&&call(res?.md5)
        }
    });
}

export function f5RefreshPage() {
    // 创建一个隐藏的iframe元素
    let iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    // 将iframe元素添加到文档中
    document.body.appendChild(iframe);
    // 监听iframe的load事件
    iframe.addEventListener('load', function () {
        // iframe加载完成后，将iframe从文档中移除
        document.body.removeChild(iframe);
        // 执行页面刷新操作
        window.location.reload();
    });
    // 设置iframe的src属性为当前页面的URL
    iframe.src = window.location.href;
}

/**
 * 格式化数字
 * @param {*} count 数字
 * @returns 格式化后的内容
 */
export function formatCount(count) {
    if ( typeof count != 'number') return count;
    if (count >= 100000 ) {
        return "10万+";
    }else if (count < 10000 ) {
        return count;
    }else if (Math.floor(count / 10000) < 10000) {
        return Math.floor(count / 1000) / 10 + '万';
    }else {
        return Math.floor(count / 10000000) / 10 + '亿';
    }
}

export function newFormatCount(count) {
    // 使用严格不等式进行类型检查
    if (typeof count !== 'number') return count;
    if (count < 10000) {
        return count;
    }
    if (count < 100000) {
        return Math.floor(count / 1000) / 10 + '万';
    }
    // 确定数值所在的10万区间
    const interval = Math.floor(count / 100000) * 100000;
    if (interval === 0) {
        return "10万+";
    } else {
        return interval / 10000 + '万+';
    }
}

export const findObject = (object, attr, value)=>{
    if(object){
        if(object instanceof Array){
            for(let i = 0 ; i < object.length; i++){
                let item = object[i];
                let res = findObject(item, attr, value);
                if(res){
                    return res;
                }
            }
        }else if(typeof object === "object"){
            for(let __attr in object){
                if(object[__attr] instanceof Array){
                    let res = findObject(object[__attr], attr, value)
                    if(res){
                        return res;
                    }
                }else{
                    if(__attr === attr && object[attr] === value){
                        return object;
                    }
                }
            }
        }
    }
    return null;
};
